define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "styled-components", "../../themes"], function (_exports, _taggedTemplateLiteralLoose2, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.NavList = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var _templateObject;

  var NavList = _styledComponents.default.ul.withConfig({
    displayName: "NavList",
    componentId: "sc-1ckh0wi-0"
  })(["align-items:center;display:flex;justify-content:flex-start;list-style:none;margin:0;padding:16px 0 0 0;flex-direction:column;> li{width:100%;}", "}"], _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    justify-content: center;\n    flex-direction: row;\n    padding: 0;\n\n    > li {\n      position: relative;\n      width: auto;\n\n      &:hover,\n      &:focus {\n        > a {\n          font-weight: ", ";\n        }\n      }\n\n      + li {\n        margin-left: 24px;\n      }\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.font.bold;
  }));

  _exports.NavList = NavList;
});